import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type SubjectTypeColorsFetchedPayload = LabeledValuePayload[];

export type SubjectTypeColorsFetchedAction = {
	type: 'SUBJECT_TYPE_COLORS_FETCHED';
	payload: SubjectTypeColorsFetchedPayload;
};

export default (payload: SubjectTypeColorsFetchedPayload): SubjectTypeColorsFetchedAction => ({
	type: 'SUBJECT_TYPE_COLORS_FETCHED',
	payload,
});
